// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"81ec3da5","71":"f198355b","197":"3e70adcd","474":"d405816c","538":"8bd23d74","564":"2e5acc05","801":"b8e037de","849":"2f5ea7b3","876":"a88e04cd","945":"d3b81a5e","966":"23ecfbb2"}[chunkId] + ".chunk.js";
};